<div class="bg-enrollment m-0 overflow-auto">
  <header>
    <div class="clearfix header-enrollment">
      <div class="container">
        <div class="logo-enrollment float-start my-3"></div>
        <!-- Contenedor del Dropdown -->
        <div class="dropdown float-end d-flex">
          <div class="text-muted py-4 pe-3">{{"DCO.enrollment_process" | translate}}</div>
          <button class="btn btn-link text-dark fw-semibold small dropdown-toggle d-flex align-items-center"
            type="button" (click)="menuAbierto = !menuAbierto; $event.stopPropagation()">
            <i class="fas fa-user-circle me-2 fa-2x"></i>
            {{ username ? username : ('Login' | translate) }}
          </button>
          <!-- Menú con clase dinámica 'show' de Bootstrap -->
          <ul class="dropdown-menu dropdown-menu-end shadow border-0" [class.show]="menuAbierto"
            style="right: 0; left: auto; background-color: white;">

            <!-- Selector de Idioma -->
            <li class="px-3 py-2" (click)="$event.stopPropagation()">
              <div class="d-flex align-items-center" style="min-width: 150px;">
                <i class="fas fa-globe me-2 text-muted"></i>
                <select class="form-select form-select-sm border-1" [(ngModel)]="selectedLanguage"
                  (change)="SetLanguage(selectedLanguage); menuAbierto = false">
                  <option *ngFor="let language of languages" [value]="language">
                    {{ language }}
                  </option>
                </select>
              </div>
            </li>
            <li>
              <hr class="dropdown-divider">
            </li>
            <!-- Opción de Logout / Login -->
            <li *ngIf="username; else loginLink">
              <button class="dropdown-item text-danger d-flex align-items-center"
                (click)="logOut(); menuAbierto = false">
                <i class="fas fa-sign-out-alt me-2"></i> {{"DCO.Title_SignOut" | translate}}
              </button>
            </li>
            <ng-template #loginLink>
              <li>
                <a class="dropdown-item d-flex align-items-center" routerLink="/login" (click)="menuAbierto = false">
                  <i class="fas fa-sign-in-alt me-2"></i> Login
                </a>
              </li>
            </ng-template>
          </ul>
        </div>
      </div>
    </div>
  </header>
  <div class="container">
    <div class="d-flex w-50 my-4 mx-auto">
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;">1</div>
          <span class="text-sm mt-2 text-nowrap">{{"DCO.Enrollment_FillInData" |
            translate}}<!--Completar datos--></span>
        </div>
        <div class="mx-4 border-bottom border-4 border-light w-100 mb-4"></div>
      </div>
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column my-auto">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;">2</div>
          <span class="text-sm mt-2 text-nowrap text-muted">{{"DCO.Enrollment_Documents" |
            translate}}<!--Documentos--></span>
        </div>
        <div class="mx-4 border-bottom border-4 border-light w-100 mb-4"></div>
      </div>
      <div class="d-flex flex-fill">
        <div class="d-flex flex-column my-auto">
          <div class="rounded-circle bg-primary p-2 text-white fw-semibold text-center mx-auto"
            style="width: 40px; height: 40px;">3</div>
          <span class="text-sm mt-2 text-nowrap text-muted">{{"DCO.Enrollment_Finish" |
            translate}}<!--Finalizar--></span>
        </div>
      </div>
    </div>
    <div class="alert alert-primary border-light d-flex mb-0">
      <div class="fa-stack pe-3">
        <i class="fa-regular fa-circle fa-stack-2x"></i>
        <i class="fa-solid fa-info fa-stack-1x"></i>
      </div>
      <div class="ps-3">
        {{ "DCO.Enrollment_VerifyDataMessage" | translate }}
        <!--Revisa los datos de tu comercio y actualiza la información de contacto si es necesario.-->
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-7 pb-5">
        <div class="card px-4 pt-2 h-100">
          <div class="card-header px-0 pb-1 border-bottom border-light">
            <h6 class="text-primary text-lg"><i
                class="fa-regular fa-building fa-lg"></i>&nbsp;&nbsp;{{"DCO.Enrollment_GeneralData" | translate}}</h6>
          </div>
          <div class="card-body px-0">
            <div class="alert alert-info border-light d-flex py-1 mb-4">
              <div class="fa-stack pe-3">
                <i class="fa-solid fa-shield fa-stack-2x"></i>
                <i class="fa-solid fa-check fa-stack-1x fa-inverse"></i>
              </div>
              <div class="ps-3">
                <span class="text-primary fw-semibold">{{ "DCO.Enrollment_VerifiedData_InfoTitle" | translate
                  }}<!--Datos verificados--></span><br>
                <span class="text-muted text-xs">{{ "DCO.Enrollment_VerifiedData_InfoText" | translate }}</span>
                <!--Los datos generales han sido verificados. Solo puedes editar los datos de contacto.-->
              </div>
            </div>
            <div class="row" *ngIf="(contact?.length > 0 || contactGroup?.length > 0)">
              <div class="col-lg-6">
                <div class="d-flex flex-column">
                  <div class="d-flex flex-column mb-3">
                    <div class="form-label fw-semibold mb-1">{{"DCO.Enrollment_MerchantName" | translate}}</div>
                    <div class="fw-semibold">{{ contactGroup[0].nameContactGroup }}</div>
                  </div>

                  <div class="d-flex flex-column mb-3">
                    <div class="form-label fw-semibold mb-1">{{"DCO.Enrollment_CreationDate" | translate}}</div>
                    <div class="fw-semibold">{{ contactGroup[0].registrationDate | date:currentFormats?.date }}</div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="d-flex flex-column">
                  <div class="d-flex flex-column mb-3">
                    <div class="form-label fw-semibold mb-1">{{"DCO.Enrollment_MerchantSingleNumber" | translate}}</div>
                    <div class="fw-semibold">{{ contactGroup[0].numberContactGroup }}</div>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="d-flex flex-column mb-1">
                  <div class="form-label fw-semibold text-primary mb-3">
                    {{ "DCO.Enrollment_MerchantNumber" | translate }}
                    &nbsp;&nbsp;&nbsp;
                    <span class="badge rounded-circle bg-primary fs-6">{{ contactCount }}</span>
                  </div>
                  <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
                    <table class="table table-sm table-hover mb-0">
                      <thead>
                        <tr>
                          <th>{{ "DCO.ClaimsClient_CommerceNumber" | translate }}</th>
                          <th>{{ "DCO.ClaimsClient_CommerceName" | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let lstContacts of contact; let i = index">
                          <td>
                            {{ lstContacts.commerceNumber }}
                          </td>
                          <td>
                            {{ lstContacts.commerceName }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-5 pb-5">
        <div class="card px-4 pt-2 h-100">
          <div class="card-header px-0 pb-1 border-bottom border-light clearfix">
            <h6 class="text-primary text-lg float-start"><i
                class="fa-regular fa-user fa-lg"></i>&nbsp;&nbsp;{{"DCO.Enrollment_ContactData" | translate}}</h6>
            <div class="float-end" *ngIf="!showBtnDocumentation && !isEditing">
              <button class="btn btn-sm btn-outline-primary" style="margin-top: -10px;" (click)="toggleEdit()">
                <i class="fa-solid fa-pen-to-square"></i>&nbsp;&nbsp;<span
                  class="fw-semibold text-xs">{{"DCO.ClaimsClient_Edit" | translate}}</span>
              </button>
            </div>
          </div>
          <div class="card-body px-0">
            <div class="d-flex flex-column" *ngIf="!isEditing && contactGroup?.length > 0">
              <div class="d-flex">
                <div class="pe-3 ps-0 py-2"><i class="fa-regular fa-envelope text-muted"></i></div>
                <div class="d-flex flex-column mb-3">
                  <div class="form-label fw-semibold mb-1">{{"DCO.MassiveInformation_Email" | translate}}</div>
                  <div class="fw-semibold text-lowercase" style="word-break: break-all;white-space: pre-line;">{{ (contactGroup[0]?.data?.TAG_mails || 'No disponible').replace(/,/g, '\n') }}
                  </div>
                </div>
              </div>
              <div class="d-flex">
                <div class="pe-3 ps-0 py-2"><i class="fa-solid fa-mobile-screen-button text-muted"></i></div>
                <div class="d-flex flex-column mb-3">
                  <div class="form-label fw-semibold mb-1">{{"DCO.MassiveInformation_Phone" | translate}}</div>
                  <div class="fw-semibold">{{ contactGroup[0]?.data?.TAG_ContactoTelf1 || 'No disponible' }}</div>
                </div>
              </div>
              <div class="d-flex">
                <div class="pe-3 ps-0 py-2"><i class="fa-solid fa-globe text-muted"></i></div>
                <div class="d-flex flex-column mb-3">
                  <div class="form-label fw-semibold mb-1">{{"DCO.Enrollment_Language" |translate}}</div>
                  <div class="fw-semibold">{{ selectedLanguage}}</div>
                </div>
              </div>
              <div class="d-flex">
                <div class="pe-3 ps-0 py-2"><i class="fa-regular fa-user text-muted"></i></div>
                <div class="d-flex flex-column mb-3">
                  <div class="form-label fw-semibold mb-1">{{"DCO.Enrollment_ContactPerson" | translate}}</div>
                  <div class="fw-semibold">{{ contactGroup[0]?.data?.TAG_Contacto || 'No disponible' }}</div>
                </div>
              </div>
              <div class="d-flex">
                <div class="pe-3 ps-0 py-2">
                  <i class="fa-regular fa-message text-muted"></i>
                </div>
                <div class="d-flex flex-column mb-3 w-100">
                  <label class="form-label fw-semibold mb-1">
                    {{"DCO.Enrollment_ContactChannel" | translate}}
                  </label>
                  <select class="form-select" disabled>
                    <option *ngFor="let option of notificationOptions" [value]="option.value"
                      [selected]="isSelected(option.value)">
                      {{ option.label | translate }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column" *ngIf="isEditing && contactGroup?.length > 0">
              <div class="d-flex flex-column mb-3">
                <div class="mb-1">
                  <i class="fa-regular fa-envelope text-muted pe-4"></i>
                  <label class="form-label fw-semibold mb-1">{{"DCO.MassiveInformation_Email" | translate}}</label>
                </div>
                <input type="email" class="form-control" [(ngModel)]="contactGroup[0].data.TAG_mails">
              </div>
              <div class="d-flex flex-column mb-3">
                <div class="mb-1">
                  <i class="fa-solid fa-mobile-screen-button text-muted pe-4"></i>
                  <label class="form-label fw-semibold mb-1">{{"DCO.MassiveInformation_Phone" | translate}}</label>
                </div>
                <input type="tel" class="form-control" [(ngModel)]="contactGroup[0].data.TAG_ContactoTelf1">
              </div>
              <div class="d-flex flex-column mb-3">
                <div class="mb-1">
                  <i class="fa-solid fa-globe text-muted pe-4"></i>
                  <label class="form-label fw-semibold mb-1">{{"DCO.Enrollment_Language" |translate}}</label>
                </div>
                <select class="form-select" [(ngModel)]="selectedLanguage" (change)="selectLanguage(selectedLanguage)">
                  <option *ngFor="let language of languages" [value]="language">
                    {{ language }}
                  </option>
                </select>
              </div>
              <div class="d-flex flex-column mb-3">
                <div class="mb-1">
                  <i class="fa-regular fa-user text-muted pe-4"></i>
                  <label class="form-label fw-semibold mb-1">{{"DCO.Enrollment_ContactPerson" | translate}}</label>
                </div>
                <input type="text" class="form-control" [(ngModel)]="contactGroup[0].data.TAG_Gestor">
              </div>
              <div class="d-flex flex-column mb-3">
                <div class="mb-1">
                  <i class="fa-regular fa-message text-muted pe-4"></i>
                  <label class="form-label fw-semibold mb-1">{{"DCO.Enrollment_ContactChannel" | translate}}:</label>
                </div>
                <div class="form-check" *ngFor="let options of notificationOptions">
                  <label class="form-check-label">
                    <input type="radio" class="form-check-input" [checked]="'email' === options.value"
                      (change)="updateSendWay(options.value)" disabled>
                    &nbsp;{{ options.label | translate}}
                  </label>
                </div>
              </div>
            </div>
            <div class="d-flex flex-row-reverse" *ngIf="isEditing">
              <div><button class="btn btn-primary text-sm fw-semibold"
                  (click)="saveChanges()">{{"DCO.MassiveInformation_Accept" | translate
                  }}</button></div>
              <div><button class="btn btn-outline-danger text-sm fw-semibold"
                  (click)="cancelEdit()">{{"DCO.MassiveInformation_Cancel" | translate
                  }}</button></div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="d-flex flex-row-reverse" *ngIf="!showBtnDocumentation && !isEditing">
          <button class="btn btn-primary text-sm fw-semibold"
            (click)="Next(contactGroup[0].contactGroupId)">{{"DCO.Enrollment_Continue"
            | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>